import React from "react";
import { Route, Redirect } from "react-router-dom";

const AdminRoute = ({ component: RouteComponent, ...rest }) => {
  return <Route {...rest} render={(routeProps) => (localStorage.getItem("admin") ? <RouteComponent {...routeProps} /> : <Redirect to={{ pathname: "/admin/login" }} />)} />;
};

export default AdminRoute;
